var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddIconBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3378 5.33826H6.96203V0.962518C6.96203 0.514224 6.5982 0.150391 6.1499 0.150391C5.70161 0.150391 5.33777 0.514224 5.33777 0.962518V5.33826H0.96203C0.513736 5.33826 0.149902 5.7021 0.149902 6.15039C0.149902 6.59868 0.513736 6.96252 0.96203 6.96252H5.33777V11.3383C5.33777 11.7866 5.70161 12.1504 6.1499 12.1504C6.5982 12.1504 6.96203 11.7866 6.96203 11.3383V6.96252H11.3378C11.7861 6.96252 12.1499 6.59868 12.1499 6.15039C12.1499 5.7021 11.7861 5.33826 11.3378 5.33826Z",
    fill: "#3671EA",
    stroke: "#3469E7",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIconBlue);
export default __webpack_public_path__ + "static/media/add_icon_blue.ac50505001d3f54b26459f6287744172.svg";
export { ForwardRef as ReactComponent };